module.exports = __webpack_public_path__ + "static/media/landing.bbd39ae3.svg";